export const capabilitiesData = {
  banner: {
    image: "/images/capabilities-banner.jpg",
    alt: "Capabilities",
  },
  breadcrumb: [
    { label: "HOME", href: "/" },
    { label: "Capabilities", href: "/capabilities" },
  ],
  title: "Capabilities",
  table: {
    headers: ["Named reactions", "Types of reaction", "Reagents and chemicals"],
    rows: [
      {
        named: "Haloform reaction",
        types: "Halogenation/Halogen exchange reaction",
        reagents: "Liquid Br2, HBr, HCl, PBPB",
      },
      {
        named: "Friedel Crafts reaction",
        types: "Halomethylation",
        reagents: "PCl5, SOCl2, POCl3,",
      },
      {
        named: "Grignard reaction",
        types: "Dehalogenation",
        reagents: "Metals like Na, Mg, Zn, nBuLi",
      },
      {
        named: "Landenburg reaction",
        types: "Carboxylation/decarboxylation",
        reagents: "Pd/C,  Pt/C,  Ru/C",
      },
      {
        named: "Jones oxidation ",
        types: "Amination, Cyanation",
        reagents: "KMnO4, MnO2, NaOCl,",
      },
      {
        named: "Prins reaction",
        types: "Esterification/ Hydrolysis",
        reagents: "Oxone, H2O2,",
      },
      {
        named: "Michael addition",
        types: "Ring closing/opening",
        reagents: "Gases like  Cl2, ethylene oxide,",
      },
      {
        named: "Mannich reaction",
        types: "Oxidation / Reduction",
        reagents: "H2, SO2,",
      },
      {
        named: "Vilsmeier heck reaction",
        types: "Dealkylation/debenzylation",
        reagents: "Chemicals like Liquid NH3,",
      },
      {
        named: "Suzuki Coupling ",
        types: "Chiral reactions & resolutions",
        reagents: "Benzyl chloride",
      },
      {
        named: "Blanc / Knoevenagel  etc..",
        types: "Hydrogenation etc.,",
        reagents: "BH3-DMS , NaBH4 etc.,",
      },
    ],
  },
};